import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';

const PasswordReset = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const email = searchParams.get('email');

  const [tokenValid, setTokenValid] = useState(null);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [verifying, setVerifying] = useState(true);

  useEffect(() => {
    const verify = async () => {
      try {
        const res = await fetch(`./backend/api/verify_reset_token.php?token=${encodeURIComponent(token || '')}&email=${encodeURIComponent(email || '')}`);
        const data = await res.json();
        if (data.success) {
          setTokenValid(true);
          setError('');
        } else {
          setTokenValid(false);
          setError(data.message || 'Lien invalide ou expiré');
        }
      } catch (e) {
        setTokenValid(false);
        setError('Erreur lors de la vérification du lien');
      } finally {
        setVerifying(false);
      }
    };

    if (token && email) verify();
    else {
      setTokenValid(false);
      setVerifying(false);
      setError('Lien incomplet');
    }
  }, [token, email]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      setError('Le mot de passe doit contenir au moins 8 caractères');
      return;
    }
    if (password !== confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }
    setLoading(true);
    setError('');
    setMessage('');
    try {
      const formData = new FormData();
      formData.append('email', email);
      formData.append('password', password);
      formData.append('token', token);

      const res = await fetch('/backend/api/reset_password.php', { method: 'POST', body: formData });
      const data = await res.json();
      if (data.success) {
        setMessage('Mot de passe réinitialisé avec succès. Vous pouvez vous connecter.');
      } else {
        setError(data.message || 'Erreur lors de la réinitialisation');
      }
    } catch (e) {
      setError('Erreur serveur');
    } finally {
      setLoading(false);
    }
  };

  if (verifying) {
    return (
      <Container className="my-5">
        <Row className="justify-content-center">
          <Col md={6}>
            <Card>
              <Card.Body>
                <div className="text-center">
                  <h4>Vérification du lien…</h4>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  if (!tokenValid) {
    return (
      <Container className="my-5">
        <Row className="justify-content-center">
          <Col md={6}>
            <Card>
              <Card.Body>
                <h4>Lien invalide</h4>
                {error && <Alert variant="danger">{error}</Alert>}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col md={6}>
          <Card>
            <Card.Body>
              <Card.Title>Réinitialiser votre mot de passe</Card.Title>
              {message && <Alert variant="success">{message}</Alert>}
              {error && <Alert variant="danger">{error}</Alert>}
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Nouveau mot de passe</Form.Label>
                  <Form.Control type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Confirmer le mot de passe</Form.Label>
                  <Form.Control type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
                </Form.Group>
                <div className="d-flex justify-content-end">
                  <Button type="submit" variant="primary" disabled={loading}>
                    {loading ? 'Enregistrement…' : 'Enregistrer'}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PasswordReset;
